import { defineComponent, PropType } from 'vue';
import props from './props';
import { MetaData, TdChatItemProps } from './type';
import Chat from './chat';
import ChatItem from './chat-item';
import ChatInput from './chat-input';
import ChatAction from './chat-action';
import { useChat } from './useChat';

export default defineComponent({
  name: 'TChatMofa',
  components: {
    Chat,
    ChatItem,
    ChatInput,
    ChatAction,
  },
  props: {
    apiKey: {
      type: String,
    },
    mofaId: {
      type: String,
      required: true,
    },
    welcome: {
      type: Array,
      default: (): String[] => [],
    },
    userMeta: {
      type: Object as PropType<MetaData>,
      default() {
        return {};
      },
    },
    assistantMeta: {
      type: Object as PropType<MetaData>,
      default() {
        return {};
      },
    },
    footer: {
      type: Boolean,
      default: true,
    },
    showUserMsg: {
      type: Boolean,
      default: true,
    },
    operationBtn: props.operationBtn,
    chatRequest: {
      type: Function,
    },
    layout: props.layout,
    onOperation: props.onOperation,
  },
  emits: ['operation', 'clear'],
  setup(props, { emit }) {
    const { chatList, loading, onStop, operation, clearConfirm, isStreamLoad, sendRequest } = useChat(props, emit);
    const handleSend = (inputValue: string) => {
      sendRequest('mofa', inputValue, props.mofaId);
    };
    return () => (
      <Chat
        layout={props.layout}
        clearHistory={chatList.value.length > 0 && !isStreamLoad.value}
        onClear={clearConfirm}
        v-slots={{
          footer: () => <ChatInput stopDisabled={isStreamLoad.value} onSend={handleSend} onStop={onStop} />,
        }}
      >
        {chatList.value.map((item: TdChatItemProps, index: number) => (
          <ChatItem
            key={index}
            avatar={item.avatar}
            role={item.role}
            datetime={item.datetime}
            content={item.content}
            text-loading={index === 0 && loading.value}
            v-slots={{
              actions: () => (
                <ChatAction
                  operationBtn={props.operationBtn}
                  content={item.content}
                  onOperation={(type, { e }) => operation(type, { e, index })}
                />
              ),
            }}
          ></ChatItem>
        ))}
      </Chat>
    );
  },
});
